import React, { useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { useQuery, useMutation } from 'react-apollo';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  DUMMY_ICON, RECENT_ACTIVITIES, dateFormats, handleGraphqlError, NUMERIC_VALUE, activityDescription,
} from '../../../utils';
import { GET_RECENT_ACTIVITIES } from '../../../graphql-client/queries';
import { LOADER_MUTATION, REMOVE_RECENT_ACTIVITY } from '../../../graphql-client/mutations';
import { OfferDetail } from '../../modals';

function RecentActivities(props) {
  const { artistId } = props;
  const { addToast } = useToasts();
  const [offerDetailModal, setOfferDetailModal] = useState(false);
  const [offerId, setOfferId] = useState(null);

  const { data } = useQuery(
    GET_RECENT_ACTIVITIES, {
      variables: { artistId },
      // pollInterval: NUMERIC_VALUE.TEN_THOUSAND,
    },
  );

  const isRecentActivityAvailable = data && data.recentActivities && data.recentActivities.data
    && data.recentActivities.data.length;

  const handleOfferId = (offerInfo) => {
    offerInfo && (() => {
      setOfferId({ offerId: offerInfo._id });
      setOfferDetailModal(true);
    })();
  };

  const [loader] = useMutation(LOADER_MUTATION, {
    variables: { show: true },
  });

  const [removeRecentActivity] = useMutation(REMOVE_RECENT_ACTIVITY, {
    variables: {},
    refetchQueries: [{
      query: GET_RECENT_ACTIVITIES,
      variables: { artistId },
    }],
    onError(error) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },

    onCompleted(deletedData) {
      loader({ variables: { show: false } });
      addToast(deletedData.removeRecentActivity.message, { appearance: 'success' });
    },
  });

  const renderActivityList = () => {
    if (data) {
      return map(data.recentActivities.data, (activity) => {
        const {
          type, email, createdAt, _id,
        } = activity;
        return (
          <div className="recent-activities-card" key={`${email}${_id}`}>
            <span className="icon icon-cross" onClick={() => { removeRecentActivity({ variables: { activityId: _id } }); }} />
            <div className="recent-activities-card-image-wrapper">
              <img
                src={(activity.offerId && activity.offerId.clientLogo) || DUMMY_ICON}
                alt="cardImage"
              />
            </div>
            <div className="recent-activities-card-info" key={createdAt}>
              <span className="recent-activities-card-date">{moment(createdAt).format(dateFormats.DATE_WITH_TIME)}</span>
              <p className="recent-activities-card-text">{activityDescription(type, email, activity.offerId)}</p>
              {activity.rejectReason
                && (
                <>
                  <h3 className="activity-name">{activity.offerId.title}</h3>
                  <h4 className="activity-error">
                    <span className="error-icon" />
                    {activity.rejectReason.custom || activity.rejectReason.preDefined}
                  </h4>
                </>
                )}
              {[RECENT_ACTIVITIES.REJECT_OFFER_REQUEST, RECENT_ACTIVITIES.ADMIN_REJECTED, RECENT_ACTIVITIES.INVITE_MANAGER].indexOf(type) === -1
                && (
                  <span
                    className="recent-activities-card-btn cursor-pointer"
                    onClick={() => handleOfferId(activity.offerId)}
                  >
                    View gigs
                    <em className="icon icon-next" />
                  </span>
                )}
            </div>
          </div>
        );
      });
    }
    return null;
  };
  return (
    <div>
      <h3 className="heading">Recent activities</h3>
      <div className="recent-activities">
        {data && isRecentActivityAvailable ? renderActivityList() : <p className="sub-heading">{RECENT_ACTIVITIES.NO_RECENT_ACTIVITY_TEXT}</p>}
      </div>
      { offerDetailModal && (
        <OfferDetail
          isOpen={offerDetailModal}
          offerIdObj={offerId}
          onClose={() => setOfferDetailModal(false)}
          artistId={artistId}
        />
      )}
    </div>
  );
}

RecentActivities.propTypes = {
  artistId: PropTypes.string.isRequired,
};

export default RecentActivities;
